import { createFileRoute } from '@tanstack/react-router';
import { GoalOverviewTab } from '@/pages/workspaces/goals/[goalId]/goal-overview-tab';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/goals/$goalId/')({
  component: withRumPageRendered(GoalOverviewTab),
});
